import script from "./AltarPaintForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AltarPaintForm.vue?vue&type=script&setup=true&lang=js"

import "./AltarPaintForm.vue?vue&type=style&index=0&id=c2b25840&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2b25840"]])

export default __exports__